import React, { useEffect } from 'react';
import { StepContainer, NavigationButtons, InfoBox } from '../index';
import { useWizard } from '../../wizard';

const DriverConsentStartStep: React.FC = () => {
  const { selfServiceData, updateSelfServiceData, goNext } = useWizard();

  useEffect(() => {
    if (selfServiceData.dlParentConsentMode !== 'koerekort_samtykke') {
      updateSelfServiceData('dlParentConsentMode', 'koerekort_samtykke');
      updateSelfServiceData('dlParentConsentRequested', true);
      updateSelfServiceData('dlUnder18', true);
      updateSelfServiceData('dlGuardian1Signed', false);
      updateSelfServiceData('dlGuardian2Signed', false);
      updateSelfServiceData('dlNotifySecondGuardian', undefined);
      updateSelfServiceData('consentChildSelectedIndex', undefined);
      updateSelfServiceData('consentManualChild', undefined);
      updateSelfServiceData('consentChildName', '');
      updateSelfServiceData('consentChildCpr', '');
      updateSelfServiceData('dlGuardian1Name', '');
      updateSelfServiceData('dlGuardian1Email', '');
      updateSelfServiceData('dlGuardian2Name', '');
      updateSelfServiceData('dlGuardian2Email', '');
    }
  }, [selfServiceData.dlParentConsentMode, updateSelfServiceData]);

  return (
    <StepContainer title="Kørekort samtykke (P23T)">
      <InfoBox type="info">
        <p>Her kan du som forælder eller værge afgive den digitale samtykkeerklæring (P23T) til kørekort for 17-årige. Flowet er en mock, der demonstrerer hvordan underskrift med MitID kan fungere i testmiljøet.</p>
        <p>Hvis du bruger linket med <code>?test=true</code>, får du vist et par demo-børn, så du kan prøve hele forløbet igennem.</p>
      </InfoBox>
      <p>Du guider selv, hvem der skal underskrive, og vi viser hvordan både ene- og fælles forældremyndighed håndteres. Svarene anvendes kun til demo og gemmes ikke i produktion.</p>
      <NavigationButtons showBack={false} onNext={goNext} nextText="Start samtykke" />
    </StepContainer>
  );
};

export default DriverConsentStartStep;

